import React, { useEffect, useReducer } from 'react'
import { createContext, ReactNode } from "react";
import { userInitial, UserReducer } from '../Store/UserReducer/UserReducer';
import { setUserData } from '../Store/UserReducer/UserActions';
import { ME } from '../../Services/Endpoint';
import { StartLoading, StopLoading } from '../Store/LoadingReducer/LoaderActions';
import { useDispatch, useSelector } from 'react-redux';
import BaseInstance from '../../Services/AxiosInstance/BaseInstance';


interface MyComponentProps {
    children?: ReactNode; // Ensure you define children prop type
}
const userContext = createContext<any>(null)


export const UserContextProvider: React.FC<MyComponentProps> = ({ children }) => {

    // const [state, dispatch] = useReducer(UserReducer, userInitial)
    const dispatch = useDispatch()
    const state = useSelector((state: any) => state.UserReducer)

    const getUserProfileData = async () => {
        try {
            dispatch(StartLoading())
            const data = await BaseInstance.get(ME).then((res) => { return res?.data })
            // updateUserContext(data)
            dispatch(setUserData(data))
        } catch (err) {
            dispatch(setUserData(userInitial))
            console.log(err)
        } finally {
            dispatch(StopLoading())
        }
    }
    const updateUserContext = async () => {
        // dispatch(setUserData(data))
        await getUserProfileData()
    }
    useEffect(() => {
        const init = async () => {
            await getUserProfileData()
        }
        init()
    }, [])
    return (
        <userContext.Provider value={{ user: state, updateUserContext }}>{children}</userContext.Provider>
    )
}

export default userContext